import React, {useCallback, useMemo, useRef, useState} from 'react';
import TemplateDefault from "../../components/template-default";
import Card from "../../components/card";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../utils/localization-ag-grid";
import {useNavigate} from "react-router-dom";
import {FaPlus} from "react-icons/fa";
import Button from "../../components/button";
import {useQuery} from "@tanstack/react-query";
import IntegrationsService from "../../services/integrations-service";
import {typeList} from "./resources/typeList";
import SelectComponent from "../../components/select-component";
import InputCheckbox from "../../components/input-checkbox";
import InputForm from "../../components/input-form";
import {buildAccentInsensitiveColDef, setAccentInsensitiveQuickFilter} from "../../utils/ag-grid-quick-filter";

const initialFilters = {
    type: "",
    conclude: false,
};
const Integration = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [filters, setFilters] = useState(initialFilters);

    const navigate = useNavigate();

    const [columnDefs] = useState([
        { field: "id", headerName: "ID", width: 70 },
        { field: "type", headerName: "Tipo", flex: 1 },
        { field: "name", headerName: "Name", flex: 1},
    ]);

    const gridRef = useRef();

    const defaultColDef = useMemo(() => buildAccentInsensitiveColDef({resizable: false}), []);

    const {data: integrations} = useQuery({
        queryFn: () => IntegrationsService.list(filters).then((data) => {
            setIsLoading(true);
            let inte = data.data

            inte.forEach(i => {
                const typeLabel = typeList.filter(t => t.value === i.type)
                i.type = typeLabel[0].label
            })
            setIsLoading(false);
            return inte
        }),
        queryKey: ['integrations', {filters}],
    });

    const onCellClicked = (params) => {

        const { event, data } = params;

        if (event.ctrlKey && event.button === 0) {
            window.open(`/integrations/form/${data.id}`);
        }else{
            navigate(`/integrations/form/${data.id}`);
        }
    };

    const handleSelect = (value, name) => setFilters(prev => ({...prev, [name]: value ? value.value : ""}));

    const onFilterTextBoxChanged = useCallback(({target}) => {
        setAccentInsensitiveQuickFilter(gridRef, target.value);
    }, []);

    return (
        <TemplateDefault title={"Integrações"} isLoading={isLoading}>
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-2 gap-y-4 lg:grid-cols-12">
                    <Button target={"primary"}
                            col={"col-span-1"}
                            onClick={() => navigate("/integrations/form")}>
                        <FaPlus/> Nova
                    </Button>

                    <div className="col-span-12 lg:col-span-3 text-gray-900">
                        <SelectComponent
                            instanceId="type"
                            label="Tipo"
                            options={typeList}
                            value={filters.type}
                            onChange={(value) => handleSelect(value, "type")}
                        />
                    </div>

                    <InputForm id="search" col="col-span-7" label="Pesquisar" type="search"
                               onChange={onFilterTextBoxChanged}/>

                    <InputCheckbox id={"conclude"} name={"conclude"} label={"Conluída"} col="col-span-12 lg:col-span-1"
                                   onChange={({target: {checked}}) => setFilters(prev => ({
                                       ...prev,
                                       conclude: checked
                                   }))}
                                   checked={filters.conclude}
                    />
                </div>

                <div className={"ag-theme-quartz grid mt-4"} style={{height: "calc(100vh - 233px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={integrations ?? []}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        pagination
                        paginationPageSize={500}
                        paginationPageSizeSelector={[20, 50, 100, 500]}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        onCellClicked={onCellClicked}
                        gridOptions={{localeText: LocalizationAgGrid}}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default Integration;
